import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { preventDefault } from '../../../utils/events'
import { TableControlIcon } from '../../Table'

import {
  getIsRentalPortalViewRegimeOptionInert,
  getRentalPortalViewRegimeNextArrowOption,
} from './RentalPortalViewRegimeControl.utils'

import * as styles from './RentalPortalViewRegimeControl.module.css'

function RentalPortalViewRegimeControl({ listViewType, options, onChange }) {
  const { t } = useTranslation()

  const containerRef = useRef(null)

  function getHandleClickOption(value) {
    return () => {
      onChange(value)
    }
  }

  function handleKeyDown(event) {
    const nextOption = getRentalPortalViewRegimeNextArrowOption({
      container: containerRef.current,
      key: event.key,
      target: event.currentTarget,
    })

    if (nextOption) {
      preventDefault(event)

      nextOption.focus()
    }
  }

  return (
    <div className={styles.RentalPortalViewRegimeControl} ref={containerRef}>
      {options.map(option => (
        <TableControlIcon
          Icon={option.Icon}
          className={classNames({ [styles.active]: option.isActive })}
          disabled={getIsRentalPortalViewRegimeOptionInert({
            listViewType,
            option,
          })}
          key={option.name}
          qaName={option.name}
          tooltip={t(option.label)}
          onClick={getHandleClickOption(option.value)}
          onKeyDown={handleKeyDown}
        />
      ))}
    </div>
  )
}

export default RentalPortalViewRegimeControl
